module.exports = __webpack_public_path__ + "80353bdee55ab7756ff959b1bc28ef96.svg";